import { Callable } from "@renproject/utils";
import axios from "axios";
import { fixUTXO, fixUTXOs, sortUTXOs, DEFAULT_TIMEOUT, } from "./API";
export var SoChainNetwork;
(function (SoChainNetwork) {
    SoChainNetwork["BTC"] = "BTC";
    SoChainNetwork["LTC"] = "LTC";
    SoChainNetwork["ZEC"] = "ZEC";
    SoChainNetwork["DOGE"] = "DOGE";
    SoChainNetwork["DASH"] = "DASH";
    SoChainNetwork["BTCTEST"] = "BTCTEST";
    SoChainNetwork["LTCTEST"] = "LTCTEST";
    SoChainNetwork["ZECTEST"] = "ZECTEST";
    SoChainNetwork["DOGETEST"] = "DOGETEST";
    SoChainNetwork["DASHTEST"] = "DASHTEST";
})(SoChainNetwork || (SoChainNetwork = {}));
export class SoChainClass {
    constructor(network = SoChainNetwork.BTC) {
        this.fetchUTXO = async (txHash, vOut) => {
            const url = `https://sochain.com/api/v2/get_tx/${this.network}/${txHash}`;
            const response = await axios.get(url, { timeout: DEFAULT_TIMEOUT });
            const tx = response.data.data;
            return fixUTXO({
                txHash: tx.txid,
                amount: tx.outputs[vOut].value.toString(),
                vOut,
                confirmations: tx.confirmations,
            }, 8);
        };
        this.fetchUTXOs = async (address, confirmations = 0) => {
            const url = `https://sochain.com/api/v2/get_tx_unspent/${this.network}/${address}/${confirmations}`;
            const response = await axios.get(url, { timeout: DEFAULT_TIMEOUT });
            return fixUTXOs(response.data.data.txs.map((utxo) => ({
                txHash: utxo.txid,
                amount: utxo.value.toString(),
                // scriptPubKey: utxo.script_hex,
                vOut: utxo.output_no,
                confirmations: utxo.confirmations,
            })), 8)
                .filter((utxo) => confirmations === 0 || utxo.confirmations >= confirmations)
                .sort(sortUTXOs);
        };
        this.fetchTXs = async (address, confirmations = 0) => {
            const url = `https://sochain.com/api/v2/get_tx_received/${this.network}/${address}/${confirmations}`;
            const response = await axios.get(url, { timeout: DEFAULT_TIMEOUT });
            return fixUTXOs(response.data.data.txs.map((utxo) => ({
                txHash: utxo.txid,
                amount: utxo.value.toString(),
                // scriptPubKey: utxo.script_hex,
                vOut: utxo.output_no,
                confirmations: utxo.confirmations,
            })), 8)
                .filter((utxo) => confirmations === 0 || utxo.confirmations >= confirmations)
                .sort(sortUTXOs);
        };
        this.broadcastTransaction = async (txHex) => {
            const response = await axios.post(`https://sochain.com/api/v2/send_tx/${this.network}`, { tx_hex: txHex }, { timeout: DEFAULT_TIMEOUT });
            return response.data.data.txid;
        };
        this.network = network;
    }
}
export const SoChain = Callable(SoChainClass);
//# sourceMappingURL=sochain.js.map